export { default as UserProfileTabFooter } from './tab-footer'